module.exports = __webpack_public_path__ + "static/Green Card-df9740aca8dfda5fa1e40fae4ea8c99c.png";